import { orderApprovalDetailsActionButtonsStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsActionButtons"
import { css } from "styled-components"

orderApprovalDetailsActionButtonsStyles.deleteButton = {
    mergeCss:true,
    css: css`
        margin-left: 10px;
    `,
    buttonType: "outline",
    variant: "secondary",
}

orderApprovalDetailsActionButtonsStyles.approveButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
}

orderApprovalDetailsActionButtonsStyles.continueShoppingButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
}

orderApprovalDetailsActionButtonsStyles.narrowOverflowMenu= {
    cssOverrides: {
        wrapper: css`
            margin-left: 20px;
            button {
                min-width: 100%;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `,
    },
}